module.exports = __webpack_public_path__ + "img/BlendBuff-Moon.106981b0.png";